import Button from './button'
import Input from './input'
import Select from './select'
import Switch from './switch'
import Checkbox from './checkbox'
import Textarea from './textarea'
import Heading from './heading'
import Menu from './menu'
import Tabs from './tabs'
import Skeleton from './skeleton'
import Modal from './modal'
import Popover from './popover'

export default {
  Button,
  Textarea,
  Input,
  Heading,
  Menu,
  Tabs,
  Switch,
  Checkbox,
  Select,
  Skeleton,
  Modal,
  Popover,
}
